import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Radio, Play, X } from "lucide-react";
import { useLightbox } from "./VideoLightbox";

export default function LiveBanner({ live }) {
  const { open } = useLightbox();
  const [dismissed, setDismissed] = useState(false);

  // Reset dismissal whenever a new live stream starts
  useEffect(() => {
    setDismissed(false);
  }, [live?.video_id]);

  if (!live || dismissed) return null;

  const handleWatch = () => open(live);

  return (
    <AnimatePresence>
      <motion.div
        initial={{ y: -60, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        exit={{ y: -60, opacity: 0 }}
        transition={{ duration: 0.4, ease: [0.22, 1, 0.36, 1] }}
        data-testid="live-banner"
        className="fixed top-0 left-0 right-0 z-[70] bg-[#C41E3A] text-white"
      >
        <div className="max-w-[1400px] mx-auto px-6 lg:px-12 h-12 flex items-center gap-4">
          <span className="flex items-center gap-2 font-mono-tech text-[10px] uppercase tracking-[0.3em] flex-shrink-0">
            <span className="relative flex h-2.5 w-2.5">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-white opacity-75" />
              <span className="relative inline-flex rounded-full h-2.5 w-2.5 bg-white" />
            </span>
            <Radio className="w-3.5 h-3.5" /> Live Now
          </span>

          <button
            onClick={handleWatch}
            data-testid="live-banner-title"
            className="flex-1 min-w-0 text-left text-sm md:text-base font-medium truncate hover:underline underline-offset-4"
          >
            {live.title}
          </button>

          <button
            onClick={handleWatch}
            data-testid="live-banner-watch-btn"
            className="hidden sm:inline-flex items-center gap-2 bg-black hover:bg-white hover:text-[#C41E3A] text-white px-4 py-1.5 text-[10px] uppercase tracking-[0.3em] font-semibold transition-colors"
          >
            <Play className="w-3 h-3 fill-current" /> Watch Live
          </button>

          <button
            onClick={() => setDismissed(true)}
            aria-label="Dismiss"
            data-testid="live-banner-dismiss"
            className="text-white/80 hover:text-white p-1 flex-shrink-0"
          >
            <X className="w-4 h-4" />
          </button>
        </div>
      </motion.div>
    </AnimatePresence>
  );
}
